import { createSlice, current } from '@reduxjs/toolkit';
import { getOrders, updateOrder } from '../thunks/orders';
import { mergeArrayByKey } from '../../utils/helpers/array';

export const ordersSlice = createSlice({
  name: 'orders',
  initialState: {
    orders: [],
    isFetching: false,
    currentPage: 1,
    limit: 10,
    totalDocs: 0,

    isUpdating: {},
  },

  reducers: {
    setCurrentPage: (state, action) => {
      if (action.payload === 1) {
        state.orders = [];
      }

      state.currentPage = action.payload;
    }
  },

  extraReducers: {
    [getOrders.pending]: (state, action) => {
      state.isFetching = true;
    },
    [getOrders.fulfilled]: (state, action) => {
      const { orders, totalDocs } = action.payload;

      state.isFetching = false;
      state.totalDocs = totalDocs;

      const currentState = current(state);
      state.orders = currentState.currentPage === 1 ? [...orders] : mergeArrayByKey([...currentState.orders, ...orders], '_id');
    },
    [getOrders.rejected]: (state, action) => {
      state.isFetching = false;
    },

    [updateOrder.pending]: (state, action) => {
      state.isUpdating[action.meta.arg.orderId] = true;
    },
    [updateOrder.fulfilled]: (state, action) => {
      const order = action.payload;

      state.isUpdating[order._id] = false;
      state.orders = state.orders.map(item => (item._id === order._id ? order : item));
    },
    [updateOrder.rejected]: (state, action) => {
      state.isUpdating[action.meta.arg.orderId] = false;
    }
  }
});

export const { setCurrentPage } = ordersSlice.actions;

export default ordersSlice.reducer;
